const headerIn = {
  dispositivo: null,
  canal: null,
  medio: null,
  aplicacion: null,
  tipoTransaccion: null,
  usuario: null,
  uuid: null,
  fechaHora: null,
  idioma: null,
  empresa: null,
  geolocalizacion: null,
  token: "",
};
let url = process.env.REACT_APP_URL;
let urlMultimedia = process.env.REACT_APP_MULTIMEDIA;
let urlElastic = process.env.REACT_APP_URL_ELASTIC;
let epaycoPurchaseReferenceUrl = process.env.REACT_APP_URL_PURCHASE_REFERENCE;
let epaycoCheckoutUrl = process.env.REACT_APP_URL_EPAYCO_CHECKOUT;
const landingIdentifier = "epayco";
const cleanUrl = window.location.origin + window.location.pathname;
const urlCatalog = cleanUrl;
const config = {
  urlMultimedia: urlMultimedia,
  api: url,
  apiElastic: urlElastic,
  headerIn: headerIn,
  landingIdentifier,
  urlCatalog,
  urlTemplate: "/vende/:idCatalog",
  epaycoPurchaseReference: epaycoPurchaseReferenceUrl,
  epaycoCheckout: epaycoCheckoutUrl,
  epaycoCheckoutVersion: process.env.REACT_APP_URL_EPAYCO_CHECKOUT_VERSION ?? "1",
  epaycoRestricId: 4877,
  marcaBlancaId: process.env.REACT_APP_MARCA_BLANCA_ID || 1588154,
  epaycoHomeUrl: process.env.REACT_APP_EPAYCO_HOME_URL || "https://epayco.com",
  epaycoRegisterUrl: process.env.REACT_APP_EPAYCO_REGISTER_URL || "https://dashboard.epayco.com/v3/register",
  epaycoValidateAccountUrl: process.env.REACT_APP_EPAYCO_VALIDATE_ACCOUNT_URL || "https://dashboard.epayco.com/validation",
  daviviendaOpenAccountUrl: process.env.REACT_APP_DAVIVIENDA_OPEN_ACCOUNT_URL || "https://dashboard.epayco.com/v3/bank-accounts",
  epaycoSupportTicketUrl: process.env.REACT_APP_EPAYCO_SUPPORT_TICKET_URL || "https://dashboard.epayco.com/soporte/nuevo",
  epaycoDashboardLoginUrl: process.env.REACT_APP_EPAYCO_DASHBOARD_LOGIN_URL || "https://dashboard.epayco.com/v3/login",
};
export const modeCheckout = process.env.REACT_APP_CHECKOUT_MODE;
export const id472 = process.env.REACT_APP_472_ID;

// URL imagenes

const ambiente = process.env.REACT_APP_AMBIENTE || "develop";

export const environment = {
  urlBaseEpayco:
    ambiente !== "master"
      ? "https://multimedia-epayco-preprod.s3.amazonaws.com"
      : "https://multimedia.epayco.co",
  urlCheckListDavivienda: 
    ambiente != "master"
      ? "https://eks-ms-davivienda-service.epayco.io"
      : "https://ms-davivienda.epayco.co"
};

// fin URL imagenes

export const epaycoMultimedia = "https://multimedia.epayco.co/dashboard/";
export const epayconUrl = process.env.REACT_APP_EPAYCO_TYC ||
  "https://epayco.com/terminos-y-condiciones-generales-2026/#tyc-usuarios-pagadores";
export const privacyPolicy = "https://epayco.com/tratamiento-de-datos/";
// export const epaycoPurchaseReference = process.env.REACT_APP_URL_PURCHASE_REFERENCE;

/************************************************************************************* */
/* NOTA SI SE CAMBIA EL VALOR EN LOCALHOST PARA PATH TAMBIEN SE DEBE CAMBIAR EL VALOR  */
/* DE LA VARIABLE DOMAIN SI NO LAS PETICIONES A LOS SERVICIOS COMO FIND Y SHIPPING     */
/* NO FUNCIONARAN CORRECTAMENTE EN LOCALHOST                                           */
/****************************************************************************************/
export const path =
  window.location.hostname === "localhost"
    ? "https://datafonos-mb.shops.epayco.io/vende/tienda-mb"
    : //? "https://ftest629819.shops.epayco.io/vende/figuras"
      cleanUrl;
export const domain =
  window.location.hostname === "localhost"
    ? "https://datafonos-mb.shops.epayco.io"
    : //? "https://ftest629819.shops.epayco.io"
      window.location.origin;

export default config;
